import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  FreeMode,
  Mousewheel,
  EffectFade,
} from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import PropTypes from "prop-types"
import { useRef } from "react"

SwiperCore.use([
  Autoplay,
  Pagination,
  Navigation,
  FreeMode,
  Mousewheel,
  EffectFade,
])

export function SliderSwiper({
  slidesPerView,
  spaceBetween,
  navigation,
  breakpoints,
  className,
  children,
  loop,
  swiperRef,
  onBeforeInit,
  pagination,
  onSwiper,
  onSlideChange,
  autoplay,
  effect,
  allowTouchMove,
}) {
  const ref = useRef()
  return (
    <Swiper
      // cssMode}}
      ref={swiperRef}
      loop={loop}
      effect={effect}
      pagination={pagination}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      navigation={navigation}
      breakpoints={breakpoints}
      className={`slider-swiper ${className}`}
      onBeforeInit={(swiper) => {
        ref.current = swiper
        if (onBeforeInit) onBeforeInit(swiper)
      }}
      onSwiper={onSwiper}
      onSlideChange={onSlideChange}
      autoplay={autoplay}
      allowTouchMove={allowTouchMove}
    >
      {children}
    </Swiper>
  )
}

SliderSwiper.propTypes = {
  loop: PropTypes.bool,
  className: PropTypes.string,
  slidesPerView: PropTypes.number,
  spaceBetween: PropTypes.number,
  navigation: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  breakpoints: PropTypes.object,
  swiperRef: PropTypes.any,
  pagination: PropTypes.bool,
  allowTouchMove: PropTypes.bool,
}

SliderSwiper.defaultProps = {
  loop: false,
  className: "",
  slidesPerView: 1.6,
  spaceBetween: 15,
  navigation: false,
  pagination: false,
  allowTouchMove: true,
  breakpoints: {
    640: {
      slidesPerView: 1.6,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3.2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 4.1,
      spaceBetween: 15,
    },
  },
}
